import type { LevelConfig, LevelPiece } from "../level_config.js";

const COMMON_DIFFICULTY = 0;
const GRID_GAP_RATIO = 0.02;

const ROWS = 5;
const COLS = 9;
const BOTTOM_ROW = 5;

const DIAG_X = Math.SQRT2 / ( 1 + GRID_GAP_RATIO );
const DIAG_Y = Math.SQRT2;
const SPACING_X = DIAG_X * 1.01;
const ROW_RISE = DIAG_Y - DIAG_Y * 1.01 / 2 + 0.01;
const FIRST_X = DIAG_X / 2 + 0.5;

function makePyramid(): { grid: number[][]; pieces: LevelPiece[] }
{
  const grid = Array.from( { length: ROWS }, () => Array<number>( COLS ).fill( 0 ) );
  const pieces: LevelPiece[] = [];
  let id = 1;

  for ( let level = 0; level < BOTTOM_ROW; level++ )
  {
    const y = ROWS - 1 - level;
    const offsetY = DIAG_Y / 2 + level * ROW_RISE - 0.5 - level;

    for ( let i = 0; i < BOTTOM_ROW - level; i++ )
    {
      const center = FIRST_X + level * SPACING_X / 2 + i * SPACING_X;
      const x = Math.floor( center );

      pieces.push( { id, type: 1, x, y, width: 1, height: 1, offsetX: center - x, offsetY, rotationDegZ: 45, variant: 0 } );
      if ( !grid[y][x] )
        grid[y][x] = id;
      id++;
    }
  }

  return { grid, pieces };
}

const ROTATED_TABLE_LEVEL: LevelConfig = {
  level: 90313,
  difficulty: COMMON_DIFFICULTY as LevelConfig["difficulty"],
  layers: [ makePyramid() ],
};

export class RotatedTableShowcase
{
  public static readonly LEVEL = ROTATED_TABLE_LEVEL.level;

  private static active = false;

  public static isActive(): boolean
  {
    return this.active;
  }

  public static activate(): number
  {
    this.active = true;
    return this.LEVEL;
  }

  public static deactivate(): void
  {
    this.active = false;
  }

  public static getConfig( level: number ): LevelConfig | null
  {
    return level === this.LEVEL ? ROTATED_TABLE_LEVEL : null;
  }
}
